import axios from "axios";
import PlatformTemporaryDocument from "@/features/PlatformDocuments/TemporaryPlatformDocument";

export class PlatformDocumentUploadService {
    private baseUploadURL = "/api/v1/platform/documents";

    async uploadDocument(document: File, workspaceID: string | null, progressCallback: (progress: number) => void): Promise<PlatformTemporaryDocument> {
        let uploadURL = this.baseUploadURL;
        if (workspaceID != null) {
            uploadURL += "?workspaceID=" + workspaceID;
        }

        const formData = new FormData();
        formData.append("file", document);
        const response = await axios.post(uploadURL, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress: function (progressEvent: ProgressEvent) {
                progressCallback(progressEvent.loaded / progressEvent.total);
            },
        });

        return response.data as PlatformTemporaryDocument;
    }
}
